import { DesktopDatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { FC, useState } from 'react';
import { Stack, Typography } from 'styles';
import palette from 'styles/theme/Palette';
import { getDateFormat, getLanguageStorage } from 'utils/localStorage';
import { useTranslation } from 'utils/translations';
import { dayjsForMaterial } from 'utils/utils';

type Props = {
	value: dayjs.Dayjs | null;
	onChange: (value: dayjs.Dayjs | null) => void;
	label: string;
	error?: boolean;
	errorText: string;
	maxDate?: dayjs.Dayjs | undefined;
	minDate?: dayjs.Dayjs | undefined;
};

const DatePickerField: FC<Props> = props => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const {
		value,
		onChange,
		label,
		error,
		errorText,
		maxDate: maxDateNF,
		minDate: mindateNF,
	} = props;

	const minDate = dayjsForMaterial(mindateNF);
	const maxDate = dayjsForMaterial(maxDateNF);

	const [invalidDate, setInvalidDate] = useState(false);

	return (
		<Stack gap={'9px'} minHeight={{ sm: '114px', lg: '130px' }}>
			<DesktopDatePicker
				value={value}
				format={getDateFormat()}
				label={label}
				onChange={e => {
					const newDate = dayjsForMaterial(e);
					const isValidDate =
						!newDate ||
						(newDate.isValid() &&
							(!maxDate || maxDate.diff(newDate) >= 0) &&
							(!minDate || newDate.diff(minDate) >= 0));
					onChange(isValidDate && newDate ? newDate : null);
					setInvalidDate(!isValidDate);
				}}
				minDate={minDate}
				maxDate={maxDate}
				disableOpenPicker
				slotProps={{
					textField: {
						variant: 'filled' as const,
						autoComplete: 'off',
						error: !!error || invalidDate,
						inputProps: {
							placeholder:
								getLanguageStorage() !== 'en-us'
									? `${tClientLabels('commons.ddmmyyyy')}`
									: `${tClientLabels('commons.mmddyyyy')}`,
						},
						InputProps: {
							disableUnderline: true,
						},
					},
				}}
			/>
			{error && (
				<Typography variant="value1" color={palette.error.main}>
					{errorText}
				</Typography>
			)}
		</Stack>
	);
};

export default DatePickerField;
